//@ts-nocheck
import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../services/actions';
import Loader from 'components/Loaders/Loader/Loader';

const stripePromise = (public_stripe_key: string) => loadStripe(public_stripe_key);

const Stripe: React.FC<React.PropsWithChildren<any>> = ({ children, ...props }) => {
  const dispatch = useDispatch();
  const public_stripe_key = useSelector(
    ({ stripe }: { stripe: any }) => stripe.public_stripe_key,
  );
  const [stripeProm, setStripeProm] = useState<any>(null)
  const { paymentIntent, clientSecret } = useSelector(
    ({ stripe }: { stripe: any }) => stripe,
  );

  useEffect(() => {
    if (!public_stripe_key)
      dispatch(actions.getTokenRequest() as any);
    if (!props.isPayment) {
      dispatch(actions.resetCard())
      dispatch(actions.createRequest())
    }
  }, []);

  useEffect(() => {
    if (!clientSecret && !props.isPayment) {
      dispatch(actions.createRequest());
    }
  }, [clientSecret])

  useEffect(() => {
    if (!stripeProm && public_stripe_key)
      setStripeProm(stripePromise(public_stripe_key))
  }, [public_stripe_key])

  if ((stripeProm && (props.isPayment && paymentIntent)) || (!props.isPayment && clientSecret)) {
    return (
      <Elements
        key={paymentIntent && props.isPayment ? paymentIntent?.paymentintent?.client_secret : clientSecret}
        stripe={stripeProm} options={paymentIntent && props.isPayment ? {
          appearance: {
            theme: 'flat',
            variables: {
              fontSizeBase: '24px',
            },
            rules: {
              '.CheckboxLabel': {
                fontSize: '28px',
              },
              '.CheckboxInput': {
                fontSize: '28px',
              },
              '.Label': {
                fontSize: '28px',
                padding: '4px',
              },
              '.Input': {
                fontSize: '28px',
              }
            }
          },
          clientSecret: paymentIntent.paymentintent.client_secret,
          customerSessionClientSecret: paymentIntent.customer_session_client_secret,
        } : {
          clientSecret: clientSecret,
        }}>{children}</Elements>
    )
  } else {
    return <Loader />
  }
};



export default Stripe;